<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import { useCombineQueryStatus } from "@/composables/useCombineQueryStatus";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useGetSettings } from "@/settings/settingsCrud";
import AreaForm from "./AreaForm.vue";
import { useGetArea, useUpdateArea } from "./areasCrud";
import { useGetAreaHouses } from "./useAreaHouses";

const props = defineProps<{
  id: string;
}>();

const { area, getAreaStatus } = useGetArea(props.id);
const { houses, getAreaHousesStatus } = useGetAreaHouses(area);
const { settings, getSettingsStatus } = useGetSettings();
const queryStatus = useCombineQueryStatus([
  getAreaStatus,
  getAreaHousesStatus,
  getSettingsStatus,
]);
const { updateArea, updateAreaStatus } = useUpdateArea();
</script>

<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Gebiete', to: { name: 'areas' } },
      { label: area?.name ?? '...' },
    ]"
  >
    <template #header>
      <h1>Gebiet bearbeiten</h1>
    </template>

    <HandleQueryStatus :query-status="queryStatus">
      <AreaForm
        v-if="area !== undefined && settings !== undefined"
        :area="area"
        :houses="houses"
        :default-map-position="settings.defaultMapPosition"
        :updating-status="updateAreaStatus"
        @update="updateArea"
      />
    </HandleQueryStatus>
  </ManagementLayout>
</template>
